// Module
var code = "<div class=\"top-container\"> <h3>Drill-down parameters</h3> </div> <div class=\"page-parameters\"></div> <div class=\"clear-parameters-container\"> <a id=\"js-clear-all\" class=\"btn-flat waves-effect waves-blue\" href=\"#\">Clear All</a> </div> ";
// Exports
export default code;